(function ($) {
   $(function () {
      $('.posts-slider .swiper').each(function () {
         var slidesS = $(this).closest('.posts-slider').data('slides-s') || 1;
         var slidesM = $(this).closest('.posts-slider').data('slides-m') || 2;
         var slidesL = $(this).closest('.posts-slider').data('slides-l') || 3;
         new Swiper(this, {
            slidesPerView: slidesS,
            spaceBetween: 16,
            loop: false, // Disabled loop d
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev',
            },
            pagination: {
               el: '.swiper-pagination',
               clickable: true,
               renderBullet: function (index, className) {
                  return '<span class="' + className + '"></span>';
               },
            },
            breakpoints: {
               768: {
                  slidesPerView: slidesM,
               },
               1024: {
                  slidesPerView: slidesL,
               },
            },
         });
      });
      $(document).on('click', '.switcher-item-btn', function (e) {
         $this = $(this);
         $this
            .closest('.switcher-wrapper')
            .find('.switcher-item.active .btn-wrapper .wp-block-button__link')
            .attr('tabindex', '-1');
         $this
            .closest('.switcher-wrapper')
            .find('.switcher-item.active')
            .removeClass('active');
         $this.closest('.switcher-item').addClass('active');
         $this
            .closest('.switcher-item')
            .find('.btn-wrapper .wp-block-button__link')
            .attr('tabindex', '0');
         var term = $this.data('term');
         var $slider = $this
            .closest('.posts-slider-container')
            .find('.swiper[data-term="' + term + '"]');
         $slider.addClass('active').siblings('.swiper').removeClass('active');
      });
   });
})(jQuery);
